import init from './init';
import update from './update';

export const buyBoxActions = {
  init,
  update
};

export type BuyBoxActions = typeof buyBoxActions;
